export const SET_SNACKBAR = "SET_SNACKBAR";
export const SET_DIALOG = "SET_DIALOG";
export const SET_WARNING_POPUP = "SET_WARNING_POPUP";
